module.exports = __webpack_public_path__ + "images/frimarken.cc5673ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/frimarken.jpg
// module id = e6619254
// module chunks = 6 16